import React from 'react';
import OptionsButton, { IButtonOption } from '../../../../../../../global/options-button/options-button';

interface IProps {
    label: JSX.Element;
    onDeleteConnectionAction: () => void;
}

const UniqueJoiningLinkOptionsButton: React.FC<IProps> = ({ label, onDeleteConnectionAction }) => {
    const options: IButtonOption[] = [
        {
            id: 'oe.connections.delete.button',
            label: 'Delete Connection',
            action: onDeleteConnectionAction,
            danger: true,
        },
    ];

    return (
        <OptionsButton
            className='options-button--right-margin-auto'
            modifier={['fat', 'options']}
            label={label}
            options={options}
            position='top'
            align='start'
        />
    );
};

export { UniqueJoiningLinkOptionsButton };
